// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { HeatmapViewSettings } from './HeatmapViewSettings';
export class HeatmapSettings {
    constructor() {
        this.viewSettings = new HeatmapViewSettings();
    }
}
